// extracted by mini-css-extract-plugin
export default {"result-list-item":"result-list-item__J2mS1"};